import styles from "src/components/elements/Button/button.module.css";
import button_next_icon from "src/assets/images/button_next_icon.svg";

type ButtonProps = {
    label: string;
    onClick: () => void;
    type: "button" | "submit";
    colors: "primary" | "secondary";
    widthInfinity?: boolean;
    isNext?: boolean;
};

/**
 * 汎用ボタンコンポーネント
 * ```:
 * props:{
 *   label: string
 *   onClick: () => void
 *   type: "button" | "submit"
 *   colors: "primary" | "secondary"
 *   widthInfinity?: boolean
 *   isNext?: boolean
 * }
 * ```
 */
const Button: React.FC<ButtonProps> = (props) => {
    return (
        <button
            className={`${
                props.colors === "primary"
                    ? styles.new_button_primary
                    : styles.new_button_secondary
            } ${props.widthInfinity ? styles.width_infinity : ""}`}
            onClick={props.onClick}
            onKeyDown={props.onClick}
            tabIndex={0}
            type={props.type === "button" ? "button" : "submit"}
        >
            {props.label}
            {props.isNext && (
                <div className={styles.next_button_icon}>
                    <img src={button_next_icon} alt="next" />
                </div>
            )}
        </button>
    );
};

export default Button;
